import { useFetchTaskTemplatesForAutocomplete } from "@/queries/useFetchTaskTemplatesForAutocomplete.ts";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";

type Option = {
    id: string;
    name: string;
};

const TaskTemplateAutocomplete = () => {
    const { setValue, formState, watch } = useFormContext();
    const [searchString, setSearchString] = useState("");
    const [inputValue, setInputValue] = useState("");

    const {
        data: { data } = {},
        isError,
        isRefetching,
        isLoading,
    } = useFetchTaskTemplatesForAutocomplete({
        searchString: searchString,
        subQueryKey: "task-template-autocomplete",
    });

    const options: Option[] = useMemo(() => {
        if (data) {
            return data.map((company) => ({
                id: company.idUUID,
                name: company.displayName ?? "",
            }));
        }

        return [];
    }, [data]);

    return (
        <>
            {isError && <Typography variant={"h5"}>Error loading task templates.</Typography>}
            <Autocomplete
                value={watch("taskTemplate") ?? ""}
                inputValue={inputValue}
                onInputChange={(_event, newInputValue) => {
                    setInputValue(newInputValue);

                    if (newInputValue.length >= 2) {
                        setSearchString(newInputValue);
                    }
                }}
                renderInput={(params) => <TextField {...params} label="Task template name" />}
                options={options}
                loading={isLoading || isRefetching}
                getOptionLabel={(option: Option) => option.name ?? ""}
                onChange={(_event, value) => {
                    setValue("taskTemplate", value);
                    setInputValue(value ? value.name : "");
                    setSearchString("");
                }}
                autoHighlight
                blurOnSelect
                sx={{
                    "& .MuiAutocomplete-inputRoot": {
                        padding: "4px!important",
                    },
                    "& .MuiAutocomplete-input": {
                        paddingTop: "4px!important",
                        paddingBottom: "4px!important",
                    },
                }}
            />
            {formState.errors.taskTemplate !== undefined && (
                <Box sx={{ color: "red", fontSize: "12px", ml: 1, mt: 1 }}>
                    You must select a task template.
                </Box>
            )}
        </>
    );
};

export default TaskTemplateAutocomplete;
